<template>
    <b-container fluid>
        <b-row class="school-container-layout" id="welcome">
            <b-col cols="12" class="welcome-content">
                <p class="welcome-text-content">
                    <span>La Universidad Católica San Pablo</span>
                    te da la Bienvenida. <br>Lo que verás a continuación es el <span>resultado obtenido del Simulacro realizado por sus estudiantes.</span>
                </p>
            </b-col>
            <b-col cols="12">
                <b-row align-h="center" class=" justify-content-lg-center mt-5 pb-xl-5">
                    <b-col lg="1"></b-col>
                    <Block :content="blocks.uno"/>
                    <Block :content="blocks.dos"/>
                    <Block :content="blocks.tres"/>
                    <b-col lg="1"></b-col>
                </b-row>
            </b-col>
            <b-col cols="12 mb-5">
                <b-row align-h="center">
                    <button class="button-primary-global" @click="goRouter('/colegio/resultados')">
                        <span class="button-text-global">IR A RESULTADOS</span>
                    </button>
                </b-row>
            </b-col>
        </b-row>

    </b-container>
</template>
<script>
    import Block from '@/components/Global/Block'

    export default {
        name: 'WelcomeSchool',
        components: {
            Block
        },
        data: () => ({
            blocks: {
                uno: {
                    titulo: '1',
                    subtitulo: 'Dirígete a resultados e <br>ingresa el Key de acceso <br>que te proporciona la UCSP',
                    imagen: 'uno.svg'
                },
                dos: {
                    titulo: '2',
                    subtitulo: 'Al ingresar podrás ver los <br>resultados por grupo y por <br>estudiante',
                    imagen: 'dos.svg'
                },
                tres: {
                    titulo: '3',
                    subtitulo: 'Sí necesitas revisar los <br> resultados más a fondo, tienes <br>la opción de descargar',
                    imagen: 'tres.svg'
                }
            }
        }),
        created() {
            this.$store.dispatch('setModulo', 'Bienvenido')
            this.$store.dispatch('setNav', 'inactive')
        },
        methods: {
            goRouter(url) {
                this.$router.push(url)
                this.$store.dispatch('setActiveRouteButton', url)
            }
        }
    }
</script>